export interface ImageSize { width: number; height: number }
export interface ImageScroll { left: number; top: number }
export type ImageFit = 'fit' | 'width' | 'actual' | 'manual';
export const IMAGE_GUTTER = 20;

export function imageFitScale(image: ImageSize, viewport: ImageSize, mode: ImageFit): number {
  if (mode === 'actual') return 1;
  const width = Math.max(1, viewport.width - IMAGE_GUTTER * 2) / Math.max(1, image.width);
  const height = Math.max(1, viewport.height - IMAGE_GUTTER * 2) / Math.max(1, image.height);
  // "Fit width" is an explicit reading mode: it fills the available width even
  // when a contact sheet is smaller than the viewport. 100% remains one click away.
  return mode === 'width' ? Math.min(8, width) : Math.min(1, width, height);
}

export function initialImageFit(image: ImageSize, viewport: ImageSize): ImageFit {
  return image.height / image.width > 1.5
    && image.height * imageFitScale(image, viewport, 'width') > viewport.height * 1.25 ? 'width' : 'fit';
}

export function imagePlacement(image: ImageSize, viewport: ImageSize, scale: number) {
  const width = image.width * scale, height = image.height * scale;
  const canvasWidth = Math.max(viewport.width, width + IMAGE_GUTTER * 2);
  const canvasHeight = Math.max(viewport.height, height + IMAGE_GUTTER * 2);
  return { width, height, canvasWidth, canvasHeight, left: (canvasWidth - width) / 2, top: (canvasHeight - height) / 2 };
}

/** Keep the image pixel beneath the pointer stationary while changing scale. */
export function imageZoomScroll(image: ImageSize, viewport: ImageSize, from: number, to: number,
  scroll: ImageScroll, point: { x: number; y: number }): ImageScroll {
  const before = imagePlacement(image, viewport, from), after = imagePlacement(image, viewport, to);
  const x = (scroll.left + point.x - before.left) / from;
  const y = (scroll.top + point.y - before.top) / from;
  return {
    left: Math.max(0, Math.min(after.canvasWidth - viewport.width, after.left + x * to - point.x)),
    top: Math.max(0, Math.min(after.canvasHeight - viewport.height, after.top + y * to - point.y)),
  };
}
